const PATCH_HIGHLIGHT_KIND = 'patch_applied';
const MAX_HIGHLIGHT_TEXT_LENGTH = 80;
const MIN_HIGHLIGHT_TEXT_LENGTH = 2;

function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function resolveText(value) {
  return String(value ?? '').trim();
}

function isSafeHighlightText(value = '') {
  const text = resolveText(value);
  return text.length >= MIN_HIGHLIGHT_TEXT_LENGTH
    && text.length <= MAX_HIGHLIGHT_TEXT_LENGTH
    && !text.includes('\n')
    && !text.includes('|');
}

function isAppliedPatchPayload(payload = {}) {
  const status = resolveObject(payload.patch_apply_status);
  return resolveText(status.status) === 'applied';
}

function patchPreviewOperations(payload = {}) {
  const preview = resolveObject(payload.patch_preview_result || payload.patch_preview);
  return resolveArray(preview.operations).map(resolveObject);
}

function reconciliationChanges(payload = {}) {
  const result = resolveObject(payload.reconciliation_result);
  const revision = resolveObject(result.context_revision);
  return resolveArray(revision.changes).map(resolveObject);
}

function uniqueTerms(values = []) {
  return values
    .map(resolveText)
    .filter(isSafeHighlightText)
    .reduce((result, value) => (
      result.includes(value) ? result : [...result, value]
    ), []);
}

function highlightTermsFromPayload(payload = {}) {
  return uniqueTerms([
    ...reconciliationChanges(payload).flatMap((change) => [
      change.new_value,
      change.replacement_text,
      change.value,
    ]),
    ...patchPreviewOperations(payload).flatMap((operation) => [
      operation.replacement_text,
      operation.new_text,
    ]),
  ]);
}

export function selectCanvasPatchHighlights(timelineItems = []) {
  const latestPayload = [...resolveArray(timelineItems)]
    .reverse()
    .map((item) => resolveObject(item?.payload))
    .find(isAppliedPatchPayload);
  return highlightTermsFromPayload(latestPayload).map((text) => ({
    text,
    kind: PATCH_HIGHLIGHT_KIND,
  }));
}

export default selectCanvasPatchHighlights;
